// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StudentDashboard.css */

.student-dashboard {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  
  .student-dashboard main {
    flex: 1 1;
  }
  
  /* Hover effects for cards */
  .student-dashboard .bg-white.shadow {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  
  .student-dashboard .bg-white.shadow:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
  
  /* Loading spinner animation */
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  .student-dashboard-loader .animate-spin {
    animation: spin 1s linear infinite;
  }
  
  /* Quick links hover effect */
  .student-dashboard .bg-gray-50.rounded-lg {
    transition: all 0.3s ease;
  }
  
  .student-dashboard .bg-gray-50.rounded-lg:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .student-dashboard .grid-cols-1 {
      gap: 1rem;
    }
    
    .student-dashboard .px-4.py-6 {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
  }
  
  /* Grade badge styles */
  .student-dashboard .bg-green-100 {
    background-color: rgba(209, 250, 229, 0.8);
  }
  
  .student-dashboard .bg-blue-100 {
    background-color: rgba(219, 234, 254, 0.8);
  }
  
  .student-dashboard .bg-yellow-100 {
    background-color: rgba(254, 243, 199, 0.8);
  }
  
  /* Mobile menu (can be expanded for hamburger menu functionality) */
  @media (max-width: 768px) {
    .student-dashboard header .hidden.md\\:block {
      /* styles for mobile menu when implemented */
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/StudentDashboard.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,SAAO;EACT;;EAEA,4BAA4B;EAC5B;IACE,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,mFAAmF;EACrF;;EAEA,8BAA8B;EAC9B;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,kCAAkC;EACpC;;EAEA,6BAA6B;EAC7B;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,iFAAiF;EACnF;;EAEA,2BAA2B;EAC3B;IACE;MACE,SAAS;IACX;;IAEA;MACE,iBAAiB;MACjB,oBAAoB;IACtB;EACF;;EAEA,uBAAuB;EACvB;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA,mEAAmE;EACnE;IACE;MACE,4CAA4C;IAC9C;EACF","sourcesContent":["/* StudentDashboard.css */\n\n.student-dashboard {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n  }\n  \n  .student-dashboard main {\n    flex: 1;\n  }\n  \n  /* Hover effects for cards */\n  .student-dashboard .bg-white.shadow {\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n  }\n  \n  .student-dashboard .bg-white.shadow:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n  \n  /* Loading spinner animation */\n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .student-dashboard-loader .animate-spin {\n    animation: spin 1s linear infinite;\n  }\n  \n  /* Quick links hover effect */\n  .student-dashboard .bg-gray-50.rounded-lg {\n    transition: all 0.3s ease;\n  }\n  \n  .student-dashboard .bg-gray-50.rounded-lg:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .student-dashboard .grid-cols-1 {\n      gap: 1rem;\n    }\n    \n    .student-dashboard .px-4.py-6 {\n      padding-top: 1rem;\n      padding-bottom: 1rem;\n    }\n  }\n  \n  /* Grade badge styles */\n  .student-dashboard .bg-green-100 {\n    background-color: rgba(209, 250, 229, 0.8);\n  }\n  \n  .student-dashboard .bg-blue-100 {\n    background-color: rgba(219, 234, 254, 0.8);\n  }\n  \n  .student-dashboard .bg-yellow-100 {\n    background-color: rgba(254, 243, 199, 0.8);\n  }\n  \n  /* Mobile menu (can be expanded for hamburger menu functionality) */\n  @media (max-width: 768px) {\n    .student-dashboard header .hidden.md\\:block {\n      /* styles for mobile menu when implemented */\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
